export const checkIsInstallmentProductsValid = (form) => {
    let allFieldsValid = true;
    if (form.attr('data-type') === 'purchase-installment-form') {
        $.each(form.find('.ods-product-row'), function (idx, row) {
            const hasValidDiscount = parseInt($(row).data('has_valid_discount'), 10);
            if (isNaN(hasValidDiscount) || !hasValidDiscount) {
                allFieldsValid = false;
            }
        });
    }
    return allFieldsValid;
};

export const checkValidFields = (form) => {

    let allFieldsValid = true;
    const errors = [];

    $.each(form.find('.ods-form-control'), function (idx, el) {

        if (el.tagName.toLowerCase() === 'input' && ($(el).attr('type') === 'checkbox' || $(el).attr('type') === 'radio')) {
            if (el.checked === false) {
                allFieldsValid = false;
                errors.push(el);
                return false;
            }

        } else if (!isNaN(parseInt($(el).attr('maxlength'), 10))) {
            const s = $(el).val() && $(el).val().toString().length <= parseInt($(el).attr('maxlength'), 10);
            if (!s) {
                allFieldsValid = false;
                errors.push(el);
                return false;
            }

        } else {
            if ($(el).hasClass('geo_city_code') || $(el).hasClass('shipping_method_exhibition')) {
                return;
            }

            if (!$(el).val() || !$(el).val().toString().trim().length) {
                allFieldsValid = false;
                errors.push(el);
                return false;
            }

        }

    });

    $.each(form.find('.select--type-radio, .input-check-wrapper'), function (idx, wrapper) {
        if (!$(wrapper).find('input:checked').length) {
            errors.push(wrapper);
            allFieldsValid = false;
        }
    });

    const imageAttachments = form.find('.attachments-item-box[data-name="image"] .attachments-item__wrapper');
    if (imageAttachments.length) {

        // if (!form.find('.attachments-item__wrapper.has-files').length) {
        if (!imageAttachments.hasClass('has-files')) {
            errors.push('.attachments-item__wrapper');
            allFieldsValid = false;
        }
    }
    // if (form.find('.g-recaptcha-response').length && !form.find('.g-recaptcha-response').val().length) {
    //     allFieldsValid = false;
    // }

    // console.log('allFieldsValid',allFieldsValid,errors);
    // if (!allFieldsValid) {
    // }
    if (form.attr('data-type') === 'purchase-installment-form') {
        if (!checkIsInstallmentProductsValid(form)) {
            allFieldsValid = false;
        }
    }

    form.find('.btn-submit').attr('disabled', !allFieldsValid);
}
